/**
 * 换脸 API
 * 提交任务：POST /web/v1/faceSwap（multipart/form-data）
 * 轮询结果：POST /web/v1/faceSwapQuery
 */
import apiClient from './config'

/**
 * 提交换脸任务
 * @param {File} inputImage - 目标图片文件
 * @param {File} sourceImage - 源人脸图片文件
 * @returns {Promise<string>} 返回 create_id
 */
export function submitFaceSwap(inputImage, sourceImage) {
  var formData = new FormData()
  formData.append('input_image', inputImage)
  formData.append('source_image', sourceImage)

  return apiClient
    .post('faceSwap', formData, {
      timeout: 120000,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(function(res) {
      var data = res.data || res
      var createId = data.create_id || data.createId
      if (createId) {
        return createId
      }
      throw new Error(res.message || '换脸任务提交失败')
    })
}

/**
 * 查询换脸任务结果
 * @param {string} createId - 任务 ID
 * @returns {Promise<{status: string, url?: string, message?: string}>}
 */
export function queryFaceSwap(createId) {
  return apiClient
    .post('faceSwapQuery', { create_id: createId }, {
      allowBizCodes: [220]
    })
    .then(function(res) {
      // 处理中：code 220
      if (res && String(res.code || '') === '220') {
        return { status: 'processing' }
      }
      // 根据外层 state 判断任务状态
      var state = (res.state || '').toLowerCase()
      if (state !== 'finished') {
        return { status: 'processing' }
      }
      // 任务完成，检查 data.code 判断是否成功
      var data = res.data || {}
      if (data.code && Number(data.code) !== 200) {
        return { status: 'failed', message: data.message || res.message || '换脸处理失败' }
      }
      var url = data.image_url || data.image || data.url || data.result_url
      if (url) {
        return { status: 'completed', url: url }
      }
      return { status: 'failed', message: '未获取到结果图片' }
    })
}

/**
 * 轮询换脸结果，直到完成或失败
 * @param {string} createId - 任务 ID
 * @param {function} callback - 回调 (err, url)
 * @param {number} interval - 轮询间隔（毫秒），默认 3000
 * @param {number} timeout - 超时时间（毫秒），默认 600000
 * @returns {{ stop: function }}
 */
export function pollFaceSwapResult(createId, callback, interval, timeout) {
  var startTime = Date.now()
  var timer = null
  var stopped = false

  interval = interval || 3000
  timeout = timeout || 600000

  function poll() {
    if (stopped) return
    queryFaceSwap(createId).then(function(result) {
      if (stopped) return
      if (result.status === 'completed') {
        callback(null, result.url)
      } else if (result.status === 'failed') {
        callback(new Error(result.message || '换脸处理失败'))
      } else {
        if (Date.now() - startTime > timeout) {
          callback(new Error('换脸处理超时'))
          return
        }
        timer = setTimeout(poll, interval)
      }
    }).catch(function(err) {
      if (stopped) return
      if (Date.now() - startTime > timeout) {
        callback(err)
        return
      }
      timer = setTimeout(poll, interval)
    })
  }

  timer = setTimeout(poll, interval)

  return {
    stop: function() {
      stopped = true
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
    }
  }
}
